<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">ANEXOS</span>
                        <div class="float-right">
                            <span class="text-primary">
                                <i
                                    class="fa fa-refresh fa-lg icon-button"
                                    title="Atualizar"
                                    @click.stop="$emit('atualizarAnexos')"
                                ></i>
                            </span>
                        </div>
                    </b-card-header>
                    <b-card-body>
                        <!-- <h5 class="heading-1 mb-4">
                            <span>ANEXOS</span>
                        </h5> -->
                        <app-tabela
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        class="mr-2"
                                        variant="primary"
                                        @click.stop="$emit('inserirAnexo')"
                                        v-if="temAcessoAtualizarAnexos && statusPermiteAtualizar"
                                        >Inserir Anexo</b-button
                                    >
                                    <b-button
                                        variant="warning"
                                        @click.stop="$emit('fecharAnexos')"
                                        ><i class="fa fa-times-circle"></i>
                                        Fechar Anexos</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="anexoTipo" slot-scope="data">
                                {{ data.anexoTipo.descricao }}
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <span class="text-danger" v-if="temAcessoAtualizarAnexos && statusPermiteAtualizar">
                                    <i
                                        class="fa fa-trash fa-lg icon-button"
                                        title="Excluir"
                                        @click.stop="confirmarExcluirAnexo(data)"
                                    ></i>
                                </span>
                                <span class="text-primary" v-if="temAcessoAtualizarAnexos && statusPermiteAtualizar">
                                    <i
                                        class="fa fa-pencil-square-o fa-lg icon-button ml-1"
                                        title="Atualizar"
                                        @click.stop="$emit('atualizarAnexo', data)"
                                    ></i>
                                </span>
                                <span class="text-primary">
                                    <i
                                        class="fa fa-download fa-lg icon-button ml-1"
                                        title="Baixar"
                                        @click.stop="$emit('baixarAnexo', data)"
                                    ></i>
                                </span>
                                <span>
                                    <visualizar-documento
                                        :parentData="data"
                                        :servicos="servicos"
                                    ></visualizar-documento>
                                </span>
                                <slot name="acoes" v-bind="data"></slot>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>

<script>

import VisualizarDocumento from './VisualizarDocumento.vue'

export default {
    components: {
        VisualizarDocumento
    },

    
    props: {
        anexos: {
            type: Array,
            default: () => ([])
        },

        temAcessoAtualizarAnexos: {
            type: Boolean,
            default: () => false
        },

        statusPermiteAtualizar: {
            type: Boolean,
            default: () => false
        },

        servicos: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'anexoTipo',
                    label: 'Tipo do Anexo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime',
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {
        confirmarExcluirAnexo(anexo) {
            this.$swal({
                title: 'Exclusão de Arquivo',
                html: `Confirma a exclusão do arquivo <b>${anexo.nomeArquivoOriginal}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.$emit('excluirAnexo', anexo)
                }
            })
        },
    },
}
</script>
